import React from 'react'
import '../App.css'
import Bodyusersreport from './bodyusersreport'
export class Bodyappusersreportbody extends React.Component {
    state = {
    }
    render() {       
        return (
            <div className="flex flex-row space-x-4"> {/* flex-row organiza los elementos horizontalmente */}
                <Bodyusersreport/>
            </div>    
        );
    }
}